<app-dialog-top>
    <div class="d-flex align-items-center">
        <span>
            <i class="fa-solid fa-shield-halved"></i>
        </span>
        <div class="">
            <p class="m-0 p-0 fs-6 lh-1">
                {{ 'ADMIN.ACCOUNTS.ACTION_RESET_MFA' | translate }}
            </p>
            @if (data.data.Email) {
                @let subTitle = data.data.Name + ' (' + data.data.Email + ')';
                <p class="m-0 p-0 fs-5 lh-1 fw-semibold" [ngbTooltip]="subTitle">
                    {{subTitle}}
                </p>
            }
        </div>
    </div>
</app-dialog-top>

<div mat-dialog-content>
    <div
        class="reset-mfa-prompt"
        [innerHTML]="'ADMIN.ACCOUNTS.PROMPT_RESET_MFA_BODY' | translate: promptParams">
    </div>
    <lib-form-reset-mfa
        class="w-100"
        [data]="data.data"
        [(submited)]="submited"
        (onClose)="close($event)"></lib-form-reset-mfa>
</div>

<app-dialog-bottom
    [saveText]="'ADMIN.ACCOUNTS.ACTION_RESET_MFA' | translate"
    (onSaveClick)="onSubmit($event)"
    (onCancelClick)="close(null)">
</app-dialog-bottom>
